export const TestType = {
  SCHEDULED: 'SCHEDULED',
  ATTEMPTED: 'ATTEMPTED',
  UNATTEMPTED: 'UNATTEMPTED',
  APPROVED: 'APPROVED'
}
